class DiscountOffCampusFilter {
    constructor() {
        this.element = document.querySelector('.search-header__multiselect');
        this.init();
    }

    init() {
        if( !this.element ) {
            return;
        }

        const toggle = this.element.querySelector('.search-header__multiselect__toggle');
        const form = this.element.querySelector('form');

        // Toggle the active class on the parent element
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            this.element.classList.toggle('is-active');
            document.body.classList.toggle('multiselect-filter-active');
        });

        // Close the dropdown when clicking outside the dropdown
        document.addEventListener('click', (e) => {
            if( !this.element.contains(e.target) && this.element.classList.contains('is-active') ) {
                this.element.classList.remove('is-active');
                document.body.classList.remove('multiselect-filter-active');
            }
        });

        // Close the dropdown when pressing the escape key
        document.addEventListener('keydown', (e) => {
            if( e.key === 'Escape' && this.element.classList.contains('is-active') ) {
                this.element.classList.remove('is-active');
                document.body.classList.remove('multiselect-filter-active');
            }
        });

        // Reset & submit the form when the reset button is clicked
        const resetButton = form.querySelector('button[type="reset"]');

        resetButton.addEventListener('click', (e) => {
            e.preventDefault();
            form.reset();
            
            form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
                checkbox.checked = false;
            });

            form.submit();
        });
    }
}

new DiscountOffCampusFilter();